module.exports = __webpack_public_path__ + "img/lesson_empty.1f39b7d1.png";